import { createContext, useContext } from "react"
export type GlobalContent = {
    isLoading: boolean
    setLoading: (value: boolean) => void
}
export const GlobalContext = createContext<GlobalContent>({
    isLoading: false, // set a default value
    setLoading: () => { },
})
export const useGlobalContext = () => useContext(GlobalContext)